class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ------------------------------------------------------------------ */
/* Herlamora filter bar + merged facets (see snippets/facets.liquid). */

/* The horizontal facet wrapper is a left slide-in drawer: scrim +
   panel with the filter groups. The [hidden] attribute carries the
   closed state (also for the restore logic); .is-open drives the slide
   transition, so opening unhides first and closing waits for the
   transition before re-hiding. Closing also collapses any open group,
   so the drawer always reopens on its root list. */
const herlamoraFacetsDrawer = {
  wrap() {
    return document.getElementById('FacetsWrapperDesktop');
  },
  toggle() {
    return document.querySelector('[data-facets-toggle]');
  },
  isOpen() {
    const wrap = this.wrap();
    return !!wrap && !wrap.hidden;
  },
  open() {
    const wrap = this.wrap();
    if (!wrap || !wrap.hidden) return;
    wrap.hidden = false;
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        wrap.classList.add('is-open');
      })
    );
    document.body.classList.add('facets-drawer-open');
    const toggle = this.toggle();
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    herlamoraClientFacets.refreshDrawer();
    const close = wrap.querySelector('.facets-drawer__close');
    if (close) close.focus();
  },
  close() {
    const wrap = this.wrap();
    if (!wrap || wrap.hidden) return;
    wrap.classList.remove('is-open');
    document.body.classList.remove('facets-drawer-open');
    const toggle = this.toggle();
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }
    window.setTimeout(() => {
      wrap.hidden = true;
      wrap.querySelectorAll('details.js-filter[open]').forEach((details) => details.removeAttribute('open'));
    }, 250);
  },
};

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-facets-toggle]')) {
    herlamoraFacetsDrawer.isOpen() ? herlamoraFacetsDrawer.close() : herlamoraFacetsDrawer.open();
    return;
  }
  if (event.target.closest('[data-facets-close]')) {
    herlamoraFacetsDrawer.close();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && herlamoraFacetsDrawer.isOpen()) herlamoraFacetsDrawer.close();
});

/* Clear buttons: the drawer footer ([data-facets-clear]) clears the
   open group ("Löschen") or, on the root list, everything ("Alle
   entfernen"); the bar's "Filter zurücksetzen" ([data-facets-clear-all],
   shown while filters are active) always clears everything.
   Programmatic unchecking fires no events, so the client pass and the
   persistence run explicitly — a merged group's mirror inputs live
   inside the same details element and are unchecked by the same
   loop. */
document.addEventListener('click', (event) => {
  const clearAll = event.target.closest('[data-facets-clear-all]');
  if (!clearAll && !event.target.closest('[data-facets-clear]')) return;
  const form = herlamoraClientFacets.form();
  if (!form) return;
  const wrap = herlamoraFacetsDrawer.wrap();
  const openGroup = clearAll ? null : wrap ? wrap.querySelector('details.js-filter[open]') : null;
  const scope = openGroup || form;
  scope.querySelectorAll('input[type="checkbox"][name^="filter."]').forEach((box) => {
    box.checked = false;
  });
  scope
    .querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
    .forEach((field) => {
      field.value = '';
    });
  if (herlamoraClientFacets.cards().length > 0 && herlamoraClientFacets.parseState(form) !== null) {
    herlamoraClientFacets.apply();
    herlamoraSaveFacets(form);
  }
});

/* Merged facet groups: a visible checkbox may represent the same value
   in several underlying filter params — sync its hidden mirror inputs
   before the (debounced) form serialization runs. Capture phase +
   delegation so it survives the AJAX re-renders of .js-filter blocks. */
document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.dataset.mergeKey || input.hasAttribute('data-merge-mirror')) return;
    document
      .querySelectorAll(`input[data-merge-mirror][data-merge-key="${CSS.escape(input.dataset.mergeKey)}"]`)
      .forEach((mirror) => {
        mirror.checked = input.checked;
      });
  },
  true
);

/* ------------------------------------------------------------------ */
/* Client-side filtering: filter changes are evaluated against the
   RENDERED cards (data-facet-card, emitted by facet-card-data.liquid)
   instead of fetching a new product list. Matching mirrors
   snippets/facet-filters-match: a card matches when at least one of
   its candidate variants satisfies every active filter group (values
   within a group OR, groups AND, an option the variant does not have
   passes automatically, and without an availability filter the
   matching variant must be purchasable). Product-level filters
   (vendor, type, tag) are matched against the card's product data.
   Sorting and pill-removal still use Dawn's AJAX path; the URL and
   Dawn's history bookkeeping are kept in sync so back-navigation and
   reloads render the same result server-side. */

const herlamoraClientFacets = {
  form() {
    return document.getElementById('FacetFiltersForm');
  },

  /* the payload script elements inside the card wrappers (see
     snippets/facet-card-data.liquid) */
  cards() {
    const grid = document.getElementById('ProductGridContainer');
    return grid ? Array.from(grid.querySelectorAll('script[data-facet-card]')) : [];
  },

  /* parsed payload per element, cached — a WeakMap frees entries with
     the elements when an AJAX render replaces the grid */
  cardDataCache: new WeakMap(),
  cardData(element) {
    if (this.cardDataCache.has(element)) return this.cardDataCache.get(element);
    let data;
    try {
      data = JSON.parse(element.textContent);
    } catch (error) {
      data = null;
    }
    // attach each candidate's colour-pattern data (data.cm maps colour
    // label -> metaobject ids): candidate.m = ids, candidate.mc =
    // lowercased labels. Scoped candidates carry the card colour, alt
    // candidates their own; without a colour option the product's
    // whole colour set applies.
    if (data && data.cm) {
      const colorKeys = Object.keys(data.cm);
      const attach = (candidate, color) => {
        if (color) {
          candidate.m = data.cm[color] || [];
          candidate.mc = data.cm[color] ? [color.toLowerCase()] : [];
        } else {
          candidate.m = colorKeys.reduce((ids, key) => ids.concat(data.cm[key]), []);
          candidate.mc = colorKeys.map((key) => key.toLowerCase());
        }
      };
      if (Array.isArray(data.v)) data.v.forEach((candidate) => attach(candidate, data.pc));
      if (Array.isArray(data.alt)) data.alt.forEach((candidate) => attach(candidate, candidate.c));
    }
    this.cardDataCache.set(element, data);
    return data;
  },

  /* null = state contains filters we cannot evaluate client-side
     (e.g. metafield filters) — Dawn's AJAX handles those */
  parseState(form) {
    const state = {
      groups: {},
      merged: [],
      colorPattern: [],
      colorLabels: [],
      availability: [],
      priceMin: null,
      priceMax: null,
      vendors: [],
      types: [],
      tags: [],
    };
    for (const [name, rawValue] of new FormData(form).entries()) {
      const value = String(rawValue);
      if (!name.startsWith('filter.')) continue;
      if (name === 'filter.v.availability') {
        state.availability.push(value);
      } else if (name === 'filter.v.price.gte') {
        if (value !== '') state.priceMin = parseFloat(value);
      } else if (name === 'filter.v.price.lte') {
        if (value !== '') state.priceMax = parseFloat(value);
      } else if (name.startsWith('filter.v.option.')) {
        const key = name.slice('filter.v.option.'.length);
        (state.groups[key] = state.groups[key] || []).push(value);
      } else if (name === 'filter.p.vendor') {
        state.vendors.push(value);
      } else if (name === 'filter.p.product_type') {
        state.types.push(value);
      } else if (name === 'filter.p.tag') {
        state.tags.push(value);
      } else if (name === 'filter.v.t.shopify.color-pattern') {
        if (value.indexOf('FilterSettingGroup') !== -1) {
          // S&D value GROUP: opaque gid — the member colour labels come
          // from the input's data-color-members (facet_color_groups
          // setting); without them the state is not client-evaluable
          const groupInput = form.querySelector(
            `input[name="filter.v.t.shopify.color-pattern"][value="${CSS.escape(value)}"][data-color-members]`
          );
          let members = [];
          try {
            members = JSON.parse(groupInput ? groupInput.dataset.colorMembers : '[]');
          } catch (error) {
            members = [];
          }
          if (!Array.isArray(members) || members.length === 0) return null;
          members.forEach((label) => {
            const norm = String(label).trim().toLowerCase();
            if (norm && !state.colorLabels.includes(norm)) state.colorLabels.push(norm);
          });
        } else {
          // plain metaobject GID, matched against cm by numeric id
          const id = parseInt(value.split('/').pop(), 10);
          if (Number.isNaN(id)) return null;
          state.colorPattern.push(id);
        }
      } else {
        return null;
      }
    }

    // Fold the params of each MERGED facet group (e.g. Größe spanning a
    // German "Größe" and an English "Size" option) into ONE logical
    // group. Per-param matching would let a value that exists in only
    // one param (socks' "35-38") auto-pass every card keyed on the
    // others (pants, shirts) — merged groups instead require a match in
    // ANY of their params and drop the auto-pass entirely, so a size
    // selection only shows cards actually offering that size.
    form.querySelectorAll('details.js-filter[id^="Details-Merged-"]').forEach((details) => {
      const keys = new Set();
      details.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]').forEach((input) => {
        keys.add(input.name.slice('filter.v.option.'.length));
      });
      if (keys.size === 0) return;
      const values = new Set();
      keys.forEach((key) => {
        (state.groups[key] || []).forEach((value) => values.add(value));
        delete state.groups[key];
      });
      if (values.size > 0) state.merged.push({ keys: [...keys], values: [...values] });
    });

    return state;
  },

  cloneState(state) {
    return {
      groups: { ...state.groups },
      merged: state.merged.map((group) => ({ keys: [...group.keys], values: [...group.values] })),
      colorPattern: [...state.colorPattern],
      colorLabels: [...state.colorLabels],
      availability: [...state.availability],
      priceMin: state.priceMin,
      priceMax: state.priceMax,
      vendors: [...state.vendors],
      types: [...state.types],
      tags: [...state.tags],
    };
  },

  candidateMatches(candidate, state) {
    if (state.availability.length) {
      const availableValue = candidate.a === 1 ? '1' : '0';
      if (!state.availability.includes(availableValue)) return false;
    } else if (candidate.a !== 1) {
      return false;
    }
    const price = candidate.p / 100;
    if (state.priceMin !== null && price < state.priceMin) return false;
    if (state.priceMax !== null && price > state.priceMax) return false;
    for (const key of Object.keys(state.groups)) {
      if (!(key in candidate.o)) continue;
      if (!state.groups[key].includes(candidate.o[key])) return false;
    }
    // merged groups: no auto-pass — a candidate without any of the
    // group's option keys fails, one with them must match in one
    for (const group of state.merged) {
      const present = group.keys.filter((key) => key in candidate.o);
      if (present.length === 0) return false;
      if (!present.some((key) => group.values.includes(candidate.o[key]))) return false;
    }
    // colour filter: no auto-pass, matching the server — a variant
    // without colour-pattern data never matches it. Plain values match
    // by metaobject id, S&D value groups by member colour label.
    if (state.colorPattern.length || state.colorLabels.length) {
      const ids = Array.isArray(candidate.m) ? candidate.m : [];
      const labels = Array.isArray(candidate.mc) ? candidate.mc : [];
      const idHit = state.colorPattern.some((id) => ids.includes(id));
      const labelHit = state.colorLabels.some((label) => labels.includes(label));
      if (!idHit && !labelHit) return false;
    }
    return true;
  },

  /* On the search results page the query itself often implies a colour
     ("burgundy longsleeve") — recolouring a card just to satisfy a SIZE
     filter would contradict what was searched. That only applies when the
     query actually named a colour, which main-search.liquid reports via
     data-search-color-query. For a plain "longsleeve" the query implies
     nothing, so the rescue must run: otherwise a product whose card happens
     to render in Black disappears the moment Navy is ticked, even though it
     is available in Navy. And when the customer picks colours in the filter
     herself, her choice outranks the colour the query hinted at. */
  colorSwapEnabled(state) {
    const searchPage = document.querySelector('.template-search');
    if (!searchPage || !searchPage.dataset.searchColorQuery) return true;
    return state.colorPattern.length > 0 || state.colorLabels.length > 0;
  },

  cardMatches(data, state) {
    if (state.vendors.length && !state.vendors.includes(data.pv)) return false;
    if (state.types.length && !state.types.includes(data.pt)) return false;
    if (state.tags.length && !state.tags.some((tag) => (data.pg || []).includes(tag))) return false;

    const candidates = Array.isArray(data.v) ? data.v : [];
    if (candidates.length === 0) {
      // no evaluable candidates: show — EXCEPT under a colour filter,
      // where the displayed colour must be provably selected (colour
      // dominates; an unprovable card must not slip through)
      return state.colorPattern.length === 0 && state.colorLabels.length === 0;
    }

    return candidates.some((candidate) => this.candidateMatches(candidate, state));
  },

  /* VCM custom-ordered collections render the product count empty on
     purpose (hide_product_count) — remember that and never write into
     the count elements there. The drawer's own count line is card-based
     and always accurate, so it is exempt. */
  countsHidden() {
    if (this._countsHidden === undefined) {
      const el = document.getElementById('ProductCountDesktop');
      this._countsHidden = !!el && el.textContent.trim() === '';
    }
    return this._countsHidden;
  },

  apply() {
    const form = this.form();
    if (!form) return;
    const state = this.parseState(form);
    if (state === null) return;

    // with no active filter every card shows — including sold-out ones
    // the server rendered; the purchasable rule only applies WITH
    // filters (matching Liquid's facet-filters-match semantics)
    const active = this.stateActive(state);

    // evaluate against the cards' UNswapped display
    this.restoreSwaps();

    const entries = this.cards().map((wrapper) => {
      const data = this.cardData(wrapper);
      return {
        wrapper,
        item: wrapper.closest('li') || wrapper,
        data,
        matches: !active || !data || this.cardMatches(data, state),
      };
    });

    // Colour swap: when every card of a product is hidden but an
    // out-of-scope (other-colour) candidate matches the state, one card
    // swaps its displayed colour to that candidate instead of the
    // product disappearing from the grid entirely.
    if (active && this.colorSwapEnabled(state)) {
      const visibleHandles = new Set();
      entries.forEach((entry) => {
        if (entry.matches && entry.data && entry.data.ph) visibleHandles.add(entry.data.ph);
      });
      const swappedHandles = new Set();
      entries.forEach((entry) => {
        if (entry.matches || !entry.data || !entry.data.ph) return;
        if (!Array.isArray(entry.data.alt) || entry.data.alt.length === 0) return;
        if (visibleHandles.has(entry.data.ph) || swappedHandles.has(entry.data.ph)) return;
        const alt = this.pickCandidate(entry.data.alt, state);
        if (!alt) return;
        this.swapCardColor(entry.item, alt, entry.data);
        entry.matches = true;
        swappedHandles.add(entry.data.ph);
      });
    }

    let visible = 0;
    let total = 0;
    entries.forEach((entry) => {
      entry.item.hidden = !entry.matches;
      total += 1;
      if (entry.matches) visible += 1;
    });

    if (!this.countsHidden()) {
      const countText = `${visible} ${visible === 1 ? 'Produkt' : 'Produkte'}`;
      const count = document.getElementById('ProductCount');
      const countDesktop = document.getElementById('ProductCountDesktop');
      if (count) count.innerHTML = countText;
      if (countDesktop) countDesktop.innerHTML = countText;
    }

    const drawerCount = document.querySelector('[data-drawer-count]');
    if (drawerCount) {
      drawerCount.textContent =
        visible === total ? `${total} Artikel` : `${visible} von ${total} Artikeln`;
    }

    this.updateCardLinks(state);
    this.renderValueCounts(state);

    // colour selections count by visible row, not by gid — a row's
    // hidden same-label mirrors are one logical selection
    const colorSelections = form.querySelectorAll(
      'input[name="filter.v.t.shopify.color-pattern"]:checked:not([data-merge-mirror])'
    ).length;
    const activeCount =
      Object.values(state.groups).reduce((sum, values) => sum + values.length, 0) +
      state.merged.reduce((sum, group) => sum + group.values.length, 0) +
      colorSelections +
      state.availability.length +
      state.vendors.length +
      state.types.length +
      state.tags.length +
      (state.priceMin !== null || state.priceMax !== null ? 1 : 0);
    const toggleCount = document.querySelector('.facets__toggle-count');
    if (toggleCount) {
      toggleCount.textContent = `(${activeCount})`;
      toggleCount.classList.toggle('hidden', activeCount === 0);
    }

    const clearBar = document.querySelector('[data-facets-clear-all]');
    if (clearBar) clearBar.classList.toggle('hidden', activeCount === 0);

    // Per-group "N ausgewählt" labels are server-rendered and Dawn only
    // refreshes them via AJAX, which we bypass — recount from the
    // checkboxes. The price facet's span shows a range, not a count.
    form.querySelectorAll('details.js-filter').forEach((details) => {
      const boxes = details.querySelectorAll('input[type="checkbox"][name^="filter."]:not([data-merge-mirror])');
      if (boxes.length === 0) return;
      const checked = Array.from(boxes).filter((box) => box.checked).length;
      details.querySelectorAll('.facets__selected').forEach((span) => {
        span.textContent = span.textContent.replace(/\d+/, checked);
      });
      const summary = details.querySelector('summary.facets__summary');
      const label = summary && summary.getAttribute('aria-label');
      if (label) summary.setAttribute('aria-label', label.replace(/\d+/, checked));
    });

    // Deliberately NO URL/history update: client-side filtering is
    // ephemeral. Filter params in the URL would make navigation and
    // reloads run Shopify's product-level filtering, which admits cards
    // whose displayed colour lacks the filtered size.
  },

  /* The first merged group with selections + its values in the
     drawer's own DOM order (which follows Shopify's option ordering) —
     the shared notion of "smallest filtered size". */
  mergedSizeOrder(state) {
    const form = this.form();
    const group = state.merged.find((mergedGroup) => mergedGroup.values.length > 0);
    const order = [];
    if (group && form) {
      form
        .querySelectorAll('input[type="checkbox"][name^="filter.v.option."]:not([data-merge-mirror])')
        .forEach((input) => {
          const key = input.name.slice('filter.v.option.'.length);
          if (group.keys.includes(key) && group.values.includes(input.value) && !order.includes(input.value)) {
            order.push(input.value);
          }
        });
    }
    return { group, order };
  },

  /* the state-matching candidate with the smallest filtered size (or
     simply the first match while no size filter is active) */
  pickCandidate(candidates, state) {
    const { group, order } = this.mergedSizeOrder(state);
    let best = null;
    let bestIndex = Infinity;
    candidates.forEach((candidate) => {
      if (!candidate.i || !this.candidateMatches(candidate, state)) return;
      let index = 0;
      if (group) {
        const key = group.keys.find((groupKey) => groupKey in candidate.o);
        index = key ? order.indexOf(candidate.o[key]) : -1;
        if (index === -1) return;
      }
      if (index < bestIndex) {
        bestIndex = index;
        best = candidate;
      }
    });
    return best;
  },

  /* Swap a card's displayed colour to an alt candidate: primary image
     src (srcset dropped), product links to the candidate's variant.
     Images come from the payload's per-colour map (data.ci). The hover
     image swaps too when the colour has its own hover media (alt-text
     tagged); otherwise it stays — a working generic hover beats a
     hidden one. Originals live in data attributes; the swap is undone
     by restoreSwaps() before every evaluation. */
  swapCardColor(item, alt, data) {
    item.dataset.hfSwapped = '1';
    const colorImages = (data.ci && data.ci[alt.c || '']) || [];
    const swapImage = (img, src) => {
      img.dataset.hfOrigSrc = img.getAttribute('src') || '';
      img.dataset.hfOrigSrcset = img.getAttribute('srcset') || '';
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
    };
    const images = item.querySelectorAll('.card__media .media img');
    images.forEach((img, index) => {
      if (index === 0) {
        if (colorImages[0]) swapImage(img, colorImages[0]);
      } else if (colorImages[1]) {
        swapImage(img, colorImages[1]);
      }
    });
    // headings that carry the colour ("Produkt - Black") follow the
    // swap — cards render TWO card__heading elements (inner + content),
    // the visible one depends on the card style, so both swap
    if (data.pc && alt.c) {
      item.querySelectorAll('.card__heading a').forEach((heading) => {
        if (!heading.textContent.includes(data.pc)) return;
        heading.dataset.hfOrigText = heading.textContent;
        heading.textContent = heading.textContent.replace(data.pc, alt.c);
      });
    }
    item.querySelectorAll('a[href*="/products/"]').forEach((anchor) => {
      if (anchor.classList.contains('card__swatch')) return;
      if (!anchor.dataset.hfOrigHref) anchor.dataset.hfOrigHref = anchor.getAttribute('href');
      const url = new URL(anchor.dataset.hfOrigHref, window.location.origin);
      url.searchParams.set('variant', alt.i);
      anchor.setAttribute('href', url.pathname + url.search + url.hash);
    });
  },

  restoreSwaps() {
    const grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    grid.querySelectorAll('[data-hf-swapped]').forEach((item) => {
      item.querySelectorAll('img[data-hf-orig-src], img[data-hf-orig-srcset]').forEach((img) => {
        if (img.dataset.hfOrigSrc !== undefined) img.setAttribute('src', img.dataset.hfOrigSrc);
        if (img.dataset.hfOrigSrcset) img.setAttribute('srcset', img.dataset.hfOrigSrcset);
        delete img.dataset.hfOrigSrc;
        delete img.dataset.hfOrigSrcset;
      });
      item.querySelectorAll('a[data-hf-orig-href]').forEach((anchor) => {
        anchor.setAttribute('href', anchor.dataset.hfOrigHref);
        delete anchor.dataset.hfOrigHref;
      });
      item.querySelectorAll('[data-hf-orig-text]').forEach((element) => {
        element.textContent = element.dataset.hfOrigText;
        delete element.dataset.hfOrigText;
      });
      delete item.dataset.hfSwapped;
    });
  },

  /* With an active size (merged-group) filter, a card's links point to
     the SMALLEST filtered size that is available for that card —
     "smallest" by the drawer's own value order. Original hrefs are kept
     in data-hf-orig-href and restored when the size filter clears.
     Colour-swatch links stay untouched: they deliberately target
     another colour's own card link. Swapped cards are skipped — their
     links already point at the swap candidate. */
  updateCardLinks(state) {
    const { group, order } = this.mergedSizeOrder(state);

    this.cards().forEach((wrapper) => {
      const item = wrapper.closest('li') || wrapper;
      if (item.dataset.hfSwapped) return;
      const anchors = Array.from(item.querySelectorAll('a[href*="/products/"]')).filter(
        (anchor) => !anchor.classList.contains('card__swatch')
      );

      if (!group || order.length === 0) {
        anchors.forEach((anchor) => {
          if (anchor.dataset.hfOrigHref) {
            anchor.setAttribute('href', anchor.dataset.hfOrigHref);
            delete anchor.dataset.hfOrigHref;
          }
        });
        return;
      }

      if (item.hidden) return;
      const data = this.cardData(wrapper);
      if (!data || !Array.isArray(data.v)) return;

      const best = this.pickCandidate(data.v, state);
      if (!best) return;

      anchors.forEach((anchor) => {
        if (!anchor.dataset.hfOrigHref) anchor.dataset.hfOrigHref = anchor.getAttribute('href');
        const url = new URL(anchor.dataset.hfOrigHref, window.location.origin);
        url.searchParams.set('variant', best.i);
        anchor.setAttribute('href', url.pathname + url.search + url.hash);
      });
    });
  },

  /* Per-value counts in the drawer, "(4)" — Shopify's product-based
     counts are intentionally not rendered (the grid expands products
     into per-colour cards), so the counts come from the card data:
     a value's count is the number of cards matching all OTHER groups'
     current state plus this value alone in its own group. */
  stateWithValue(state, name, value) {
    const probe = this.cloneState(state);
    if (name === 'filter.v.availability') probe.availability = [value];
    else if (name.startsWith('filter.v.option.')) probe.groups[name.slice('filter.v.option.'.length)] = [value];
    else if (name === 'filter.p.vendor') probe.vendors = [value];
    else if (name === 'filter.p.product_type') probe.types = [value];
    else if (name === 'filter.p.tag') probe.tags = [value];
    else if (name === 'filter.v.t.shopify.color-pattern') {
      const id = parseInt(value.split('/').pop(), 10);
      if (Number.isNaN(id)) return null;
      probe.colorPattern = [id];
    } else return null;
    return probe;
  },

  /* How many cards apply() would show under this state: the matching
     cards plus one colour-swap rescue per otherwise-invisible product
     — the SAME algorithm as the swap pass, so the drawer's value
     counts always equal what checking the value displays. */
  visibleCountFor(cardData, state) {
    let count = 0;
    const matchedHandles = new Set();
    const unmatched = [];
    cardData.forEach((data) => {
      if (!data || this.cardMatches(data, state)) {
        count += 1;
        if (data && data.ph) matchedHandles.add(data.ph);
        return;
      }
      unmatched.push(data);
    });
    if (this.colorSwapEnabled(state)) {
      const rescuedHandles = new Set();
      unmatched.forEach((data) => {
        if (!data.ph || matchedHandles.has(data.ph) || rescuedHandles.has(data.ph)) return;
        if (!Array.isArray(data.alt)) return;
        if (data.alt.some((candidate) => candidate.i && this.candidateMatches(candidate, state))) {
          rescuedHandles.add(data.ph);
          count += 1;
        }
      });
    }
    return count;
  },

  renderValueCounts(state) {
    const form = this.form();
    if (!form) return;
    const cardData = this.cards().map((wrapper) => this.cardData(wrapper));
    form.querySelectorAll('label.facet-checkbox').forEach((label) => {
      const span = label.querySelector('[data-facet-count]');
      const input = label.querySelector('input[type="checkbox"][name^="filter."]');
      if (!span || !input) return;
      // for a value in a merged group the probe replaces that WHOLE
      // logical group (all underlying params) with just this value —
      // same semantics cardMatches applies
      const details = input.closest('details.js-filter');
      let probe;
      if (details && details.id.startsWith('Details-Merged-')) {
        const keys = new Set();
        details.querySelectorAll('input[type="checkbox"][name^="filter.v.option."]').forEach((groupInput) => {
          keys.add(groupInput.name.slice('filter.v.option.'.length));
        });
        probe = this.cloneState(state);
        probe.merged = probe.merged
          .filter((group) => !group.keys.some((key) => keys.has(key)))
          .concat([{ keys: [...keys], values: [input.value] }]);
      } else if (input.name === 'filter.v.t.shopify.color-pattern') {
        // a colour row can stand for several instances (hidden mirrors)
        // and its value can be a plain metaobject gid or an S&D value
        // group — the probe replaces the whole colour selection with
        // this row's ids and/or member labels
        probe = this.cloneState(state);
        probe.colorPattern = [];
        probe.colorLabels = [];
        const rowInputs = input.dataset.mergeKey
          ? form.querySelectorAll(
              `input[name="filter.v.t.shopify.color-pattern"][data-merge-key="${CSS.escape(input.dataset.mergeKey)}"]`
            )
          : [input];
        rowInputs.forEach((rowInput) => {
          if (rowInput.value.indexOf('FilterSettingGroup') !== -1) {
            let members = [];
            try {
              members = JSON.parse(rowInput.dataset.colorMembers || '[]');
            } catch (error) {
              members = [];
            }
            (Array.isArray(members) ? members : []).forEach((label) => {
              const norm = String(label).trim().toLowerCase();
              if (norm && !probe.colorLabels.includes(norm)) probe.colorLabels.push(norm);
            });
          } else {
            const id = parseInt(rowInput.value.split('/').pop(), 10);
            if (!Number.isNaN(id) && !probe.colorPattern.includes(id)) probe.colorPattern.push(id);
          }
        });
        if (probe.colorPattern.length === 0 && probe.colorLabels.length === 0) probe = null;
      } else {
        probe = this.stateWithValue(state, input.name, input.value);
      }
      if (probe === null) {
        span.textContent = '';
        return;
      }
      span.textContent = `(${this.visibleCountFor(cardData, probe)})`;
    });
  },

  stateActive(state) {
    return (
      Object.keys(state.groups).length > 0 ||
      state.merged.length > 0 ||
      state.colorPattern.length > 0 ||
      state.colorLabels.length > 0 ||
      state.availability.length > 0 ||
      state.vendors.length > 0 ||
      state.types.length > 0 ||
      state.tags.length > 0 ||
      state.priceMin !== null ||
      state.priceMax !== null
    );
  },

  /* Called when the drawer opens: brings the grid, count line and
     per-value counts up to date (apply() shows everything when no
     filter is active). */
  refreshDrawer() {
    const form = this.form();
    if (!form || this.cards().length === 0) return;
    if (this.parseState(form) === null) return;
    this.apply();
  },
};

/* Re-apply the client pass after any legitimate AJAX grid render
   (sorting, pill removal): the fetched grid is server-filtered at
   product level only. */
if (typeof FacetFiltersForm !== 'undefined') {
  const herlamoraOriginalRenderGrid = FacetFiltersForm.renderProductGridContainer;
  FacetFiltersForm.renderProductGridContainer = function (html) {
    herlamoraOriginalRenderGrid.call(FacetFiltersForm, html);
    const form = herlamoraClientFacets.form();
    if (form && herlamoraClientFacets.cards().length > 0 && herlamoraClientFacets.parseState(form) !== null) {
      herlamoraClientFacets.apply();
      herlamoraSaveFacets(form);
    }
  };
}

/* Intercept filter-input events (capture phase, before Dawn's form
   listener) and route them to the client-side engine. Falls through to
   Dawn's AJAX only when there are no client-filterable cards or the
   state contains unsupported filters. */
let herlamoraFacetsTimer = null;
const herlamoraFacetsIntercept = (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement)) return;
  if (!input.name || !input.name.startsWith('filter.')) return;
  const form = input.closest('#FacetFiltersForm');
  if (!form) return;
  if (herlamoraClientFacets.cards().length === 0) return;

  // merged-facet mirrors must reflect this change before serialization
  if (input.dataset.mergeKey && !input.hasAttribute('data-merge-mirror')) {
    document
      .querySelectorAll(`input[data-merge-mirror][data-merge-key="${CSS.escape(input.dataset.mergeKey)}"]`)
      .forEach((mirror) => {
        mirror.checked = input.checked;
      });
  }

  if (herlamoraClientFacets.parseState(form) === null) return;

  event.stopPropagation();
  clearTimeout(herlamoraFacetsTimer);
  herlamoraFacetsTimer = setTimeout(() => {
    herlamoraClientFacets.apply();
    herlamoraSaveFacets(form);
  }, input.type === 'checkbox' ? 50 : 400);
};

/* Dawn triggers on 'input'; PriceRange additionally listens on 'change'
   directly on the price fields — both routes must be covered. */
document.addEventListener('input', herlamoraFacetsIntercept, true);
document.addEventListener('change', herlamoraFacetsIntercept, true);

/* Persisted filter state: the checked filter pairs are written to
   localStorage on every user change (and after pill-removal/clear-all
   AJAX renders) and re-applied on later collection/search page loads —
   pairs without a matching input on the current page are ignored but
   kept in storage. */
const HERLAMORA_FACETS_STORAGE_KEY = 'herlamora:facets';
const HERLAMORA_FACETS_TTL = 7 * 24 * 60 * 60 * 1000;

const herlamoraSaveFacets = (form) => {
  try {
    const pairs = [];
    for (const [name, value] of new FormData(form).entries()) {
      if (name.startsWith('filter.') && String(value) !== '') pairs.push([name, String(value)]);
    }
    localStorage.setItem(HERLAMORA_FACETS_STORAGE_KEY, JSON.stringify({ t: Date.now(), pairs }));
  } catch (error) {
    /* storage full/blocked — persistence is best-effort */
  }
};

const herlamoraApplyStoredFacets = (form) => {
  let stored;
  try {
    stored = JSON.parse(localStorage.getItem(HERLAMORA_FACETS_STORAGE_KEY) || 'null');
  } catch (error) {
    stored = null;
  }
  if (!stored || !Array.isArray(stored.pairs)) return;
  if (Date.now() - (stored.t || 0) > HERLAMORA_FACETS_TTL) return;

  stored.pairs.forEach(([name, value]) => {
    if (name === 'filter.v.price.gte' || name === 'filter.v.price.lte') {
      const field = form.querySelector(`input[name="${CSS.escape(name)}"]`);
      if (field) field.value = value;
      return;
    }
    const input = form.querySelector(
      `input[name="${CSS.escape(name)}"][value="${CSS.escape(value)}"]:not([data-merge-mirror])`
    );
    if (input) input.checked = true;
  });
};

/* Restore-consistency pass: after a reload the browser restores the
   checkbox states (form restoration) while the grid renders unfiltered
   (the URL is clean by design), and URLs with filter params render
   server-filtered at product level only. On top of that, filters
   persisted in localStorage are applied when the page has no active
   state of its own. In all cases: sync the merge mirrors to the
   visible checkboxes, and when any filter is active, apply the client
   pass (the drawer stays closed — the toggle badge shows the state). */
const herlamoraFacetsRestore = () => {
  const form = herlamoraClientFacets.form();
  if (!form || herlamoraClientFacets.cards().length === 0) return;

  const initialState = herlamoraClientFacets.parseState(form);
  const initialActive = initialState !== null && herlamoraClientFacets.stateActive(initialState);
  if (!initialActive) herlamoraApplyStoredFacets(form);

  form
    .querySelectorAll('input[data-merge-key]:not([data-merge-mirror])')
    .forEach((input) => {
      document
        .querySelectorAll(`input[data-merge-mirror][data-merge-key="${CSS.escape(input.dataset.mergeKey)}"]`)
        .forEach((mirror) => {
          mirror.checked = input.checked;
        });
    });

  const state = herlamoraClientFacets.parseState(form);
  if (state === null) return;
  if (!herlamoraClientFacets.stateActive(state)) return;

  // the toggle badge updates inside apply(); the drawer itself stays
  // closed — active filters are visible via the badge, not a popped-up
  // sidebar
  herlamoraClientFacets.apply();
};

document.addEventListener('DOMContentLoaded', herlamoraFacetsRestore);
/* form restoration can happen as late as the load event */
window.addEventListener('load', () => setTimeout(herlamoraFacetsRestore, 0));
/* back/forward cache restores the full page state without any events */
window.addEventListener('pageshow', (event) => {
  if (event.persisted) herlamoraFacetsRestore();
});
